<template>
  <Head>
    <title>{{ entry.seo.title }}</title>
    <meta property="description" :content="entry.seo.description" />
  </Head>

  <Layout :alerts="entry.alerts">
    <PageIntro :data="entry.pageMasthead"></PageIntro>

    <SectionTextWithImg :data="entry.pageComponents.sectionText[0]" />

    <CardGrid :data="entry.pageComponents.ctaCardGroup[0]" />

    <SectionHeading>Review investment options</SectionHeading>

    <div
      v-for="(component, key) in entry.pageComponents.investmentFundGroups"
      :key="key">
      <SectionTextWIthImgBottom v-if="component.investmentFunds.length === 1">
        <template #title>{{ component.title }}</template>
        <template #body>
          <span v-html="component.description"></span>
        </template>
        <template #content>
          <InvestmentCard
            class="h-auto"
            :data="component.investmentFunds[0]"
            :headingTag="'h4'"
            :linkText="'View Fund Summary'">
          </InvestmentCard>
        </template>
      </SectionTextWIthImgBottom>

      <div v-else>
        <SectionTextWithImg
          :data="{ title: component.title, body: component.description }" />

        <Container class="section-spacing">
          <Grid :numCols="4" :isLastColCenter="false">
            <GridItem
              v-for="(item, key) in component.investmentFunds"
              :key="key">
              <InvestmentCard
                class="h-full w-full"
                :data="item"
                :headingTag="'h4'"
                :linkText="'View Fund Summary'">
              </InvestmentCard>
            </GridItem>
          </Grid>
        </Container>
      </div>
    </div>

    <Footnotes
      :footnotes="entry.pageComponents.footnotes[0].footnotes"></Footnotes>
  </Layout>
</template>

<script>
import JarCoinsImg from "../../../images/illustrations/ill-jar-coins.svg";
import PiggyBankImg from "../../../images/illustrations/ill-piggy-bank.svg";
import ArrowImg from "../../../images/icons/icon-arrow-down.svg";

import Container from "../../Components/Atoms/Container.vue";
import Footnotes from "../../Components/Atoms/Footnotes.vue";
import Grid from "../../Components/Atoms/Grid/GridContainer.vue";
import GridItem from "../../Components/Atoms/Grid/GridItem.vue";
import InvestmentCard from "../../Components/Modules/CardInvestment.vue";
import SectionHeading from "../../Components/Page-Components/SectionHeading.vue";
import SectionTextWithImg from "../../Components/Page-Components/SectionTextWithImg.vue";
import SectionTextWIthImgBottom from "../../Components/Page-Components/SectionTextWithImgBottom.vue";
import Title from "../../Components/Atoms/Heading.vue";
import CardGrid from "../../Components/Page-Components/CardGrid.vue";

export default {
  components: {
    CardGrid,
    Container,
    Grid,
    GridItem,
    InvestmentCard,
    SectionHeading,
    SectionTextWithImg,
    SectionTextWIthImgBottom,
    Title,
    Footnotes,
  },

  props: {
    entry: Object,
    siteUrl: String,
    seo: Object,
  },

  setup() {
    const slotName = (key) => {
      return "col_" + key;
    };

    const data = {
      twoCol: {
        one: {
          img: {
            src: JarCoinsImg,
            alt: "",
          },
          arrow: {
            src: ArrowImg,
            alt: "",
          },
        },
        two: {
          img: {
            src: PiggyBankImg,
            alt: "",
          },
        },
      },
    };

    return {
      slotName,
      data,
    };
  },
};
</script>
